import React, { Component } from "react";
import { Container, Row, Col, Form, Button } from "reactstrap";
import { Link } from "react-router-dom";

//Import Image
import img from "../../assets/images/onepage/bg.png";
import classic from "../../assets/images/property-management/classic.png";

const TopSection = ({ onDrawerOpen, isDrawerOpen }) => {

  return (
    <React.Fragment>
      <section
        className="bg-home bg-light d-flex align-items-center"
        style={{ background: `url(${img}) top left no-repeat`, height: "auto" }}
        id="home"
      >
        <Container>
          <Row className="justify-content-center">
            <Col md="9" className="text-center mt-0 mt-md-5 pt-0 pt-md-5">
              <div className="title-heading margin-top-100">
                <h1
                  className="heading mb-3"
                  data-aos="fade-up"
                  data-aos-duration="1000"
                >
                  Property Management Software{" "}<br />
                  <span style={{ color: "#f7961c" }}>For Landlords</span>
                </h1>
                <p
                  className="para-desc mx-auto text-muted"
                  data-aos="fade-up"
                  data-aos-duration="1400"
                >
                  Manage your rentals with ease. Easliy communicate with tenants, track rent payments, and manage maintenance requests.
                </p>
                <div className="mt-4" style={{ display: 'flex', justifyContent: 'center' }}>
                  {/* <Link to="//app.zenstrin.com/signup" target="_blank" rel="noopener noreferrer" className="btn btn-pills btn-primary mt-2 me-2" style={{ display: 'flex', }}>
                    <div>
                      <strong className="d-block " style={{ fontWeight: 'medium', fontSize: 17 }}>Start Free Trial</strong>
                    </div>
                  </Link> */}
                  <Link to="#" onClick={onDrawerOpen} disabled={isDrawerOpen} className="btn btn-pills btn-outline-primary mt-2 ms-1" style={{ display: 'flex', }}>
                    <div>
                      <strong className="d-block " style={{ fontWeight: 'medium', fontSize: 17 }}>
                        Request Demo
                      </strong>
                    </div>
                  </Link>
                </div>
                {/* <div
                  className="text-center subcribe-form mt-4 pt-2"
                  data-aos="fade-up"
                  data-aos-duration="1800"
                >
                  <Form>
                    <div className="mb-0">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="shadow bg-white rounded-pill"
                        // required
                        placeholder="Email Address"
                      />
                      <Button
                        type="submit"
                        color="primary"
                        className="btn-pills"
                        onClick={onDrawerOpen}
                        disabled={isDrawerOpen}
                      >
                        Request Demo
                      </Button>
                    </div>
                  </Form>
                </div> */}
              </div>

              <div
                className="home-dashboard onepage-hero"
                data-aos="fade-up"
                data-aos-duration="2200"
              >
                <img src={classic} alt="" className="img-fluid rounded" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
}

export default TopSection;
